import { useEffect } from "react";

const GA4 = process.env.REACT_APP_GA4_ID;
const GTM = process.env.REACT_APP_GTM_ID;

export const Analytics = () => {
  useEffect(() => {
    if (GTM) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${GTM}`;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
      document.head.appendChild(s);
    }
    if (GA4) {
      const s = document.createElement("script");
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${GA4}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag("js", new Date());
      window.gtag("config", GA4);
    }
  }, []);
  return null;
};
